import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { UserDocumentsManagementState, initialState } from './user-documents-management.state';
import * as userDocumentsManagementActions from '@state/user-documents-management/user-documents-management.actions';

const reducer: ActionReducer<UserDocumentsManagementState, Action> = createReducer(
  initialState,

  on(
    userDocumentsManagementActions.getUserProcessSummaryDocuments,
    (state): UserDocumentsManagementState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    userDocumentsManagementActions.getUserProcessSummaryDocumentsSuccess,
    (state, { userDocs }): UserDocumentsManagementState => ({
      ...state,
      userDocs,
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    userDocumentsManagementActions.getUserProcessSummaryDocumentsError,
    (state, { errorMessage }): UserDocumentsManagementState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  ),

  on(
    userDocumentsManagementActions.getAdditionalDocumentsAnswers,
    (state): UserDocumentsManagementState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    userDocumentsManagementActions.getAdditionalDocumentsAnswersSuccess,
    (state, { userDocsAnswers }): UserDocumentsManagementState => ({
      ...state,
      userDocsAnswers,
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    userDocumentsManagementActions.getAdditionalDocumentsAnswersError,
    (state, { errorMessage }): UserDocumentsManagementState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  )
);

export function userDocumentsManagementReducer(
  state: UserDocumentsManagementState,
  action: Action
): UserDocumentsManagementState {
  return reducer(state, action);
}
